import classNames from 'classnames/bind';
var style = classNames.bind({});
export default style;
